export default "__VITE_ASSET__kX84Um6q__"